var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "button-container" }, [
    _c("div", { staticClass: "line-before" }),
    _c("button", { staticClass: "dateStyle" }, [_vm._v(_vm._s(_vm.separator))]),
    _c("div", { staticClass: "line-after" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }